import { render } from "./HeaderChallengeSelectMode.vue?vue&type=template&id=642147e4&scoped=true"
import script from "./HeaderChallengeSelectMode.vue?vue&type=script&lang=js"
export * from "./HeaderChallengeSelectMode.vue?vue&type=script&lang=js"

import "@/css/components/header-challenge-select-mode.css?vue&type=style&index=0&id=642147e4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642147e4"]])

export default __exports__